import * as React from 'react';
import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import * as SalesStore from '../SalesStore';

import { Permission, Res } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { PosScreenClassComponent, DialogIcon, ScreenSize, ActionButtonDefinition } from 'pos/ui';
import { Command } from 'pos/common';
import { Cols, Col } from 'core/ui';
import { Modal } from 'core/ui-next/modal';

type Props = {
	minTicketAmount: number
} & Modal.Actions<number>;

type State = {
	minTicketAmount: number
};

class SetMinTicketAmountScreen extends PosScreenClassComponent<Props, State> {

	private form = React.createRef<UI.Form<State>>();
	private txtAmount = React.createRef<UI.PriceBox<State>>();

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getScreenId(): string {
		return 'SET_MIN_TICKET_AMOUNT';
	}

	protected getTitle(): string {
		return Res.Web.SET_MIN_TICKET_AMOUNT();
	}

	protected getImage(): string | SvgIcon {
		return Images.SetMinTicketAmount;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({ onOK: this.onOK });
	}

	protected useKeypad = () => true;

	private onOK = async () => {
		const valid = await this.form.current!.updateModel();
		if (valid)
			this.close(this.state.minTicketAmount);
	};

	protected getContent(): React.ReactNode {
		const { Form, PriceBox } = UI.controlsFor<State>();

		return <Form small ref={this.form} model={this.state}>
			<DialogIcon src={Images.SetMinTicketAmount} />
			<Cols>
				<Col width='*' className='m-t-sm'>
					<PriceBox className='text-center' ref={this.txtAmount} linkTo={x => x.minTicketAmount} placeholder={Res.Web.SET_MIN_TICKET_AMOUNT_PLACEHOLDER()} onEnterPress={this.onOK} />
				</Col>
			</Cols>
		</Form>;
	}

	createInitialState(props: Props): Nullable<State> {
		return { minTicketAmount: props.minTicketAmount };
	}

	onComponentDidMount(): void {
		this.txtAmount.current!.activate();
	}

	onComponentWillUnmount(): void {
	}
}

declare global {
	interface CommandType {
		setMinTicketAmount: () => Promise<Result>
	}
}

Command.register('setMinTicketAmount', Preconditions.ensure(Permission.Ticket_SetMinTicketAmount), async (): Promise<Result> => {
	const previousAmount = SalesStore.getTicket().MinRequiredAmount;

	const result = await Modal.show(SetMinTicketAmountScreen, { minTicketAmount: previousAmount });
	if (!result.ok)
		return Result.error();

	await SalesStore.setMinTicketAmount(result.value);

	return Result.ok();
});